export enum EurotaxSelectionSteps {
    SUMMARY = "summary",
    DETAILS = "details",
    SELECTION = "selection",
    NONE = "",
}
